export const marketing = {
  fr: {
    nav: ['Fonctionnalités', 'Hébergement', 'Questions'],
    login: 'Se connecter',
    start: 'Créer mon espace',
    dashboard: 'Ouvrir mon espace',
    skip: 'Aller au contenu',
    menu: 'Navigation',
    eyebrow: 'VOTRE TRAVAIL, DU PREMIER ÉCHANGE AU DERNIER DÉTAIL',
    title: 'Moins de dispersion.',
    emphasis: 'Plus de concret.',
    intro:
      'Vos projets, vos réunions et vos emails ont enfin un point de rencontre. Transformez les échanges en tâches, gardez le contexte et faites avancer votre équipe.',
    explore: 'Explorer le produit',
    professional: 'Pour les professionnels · SaaS en France ou auto-hébergement',
    demo: 'Aperçu illustratif du produit',
    demoProject: 'Lancement du nouveau site',
    demoWorkspace: 'Mon espace',
    demoTabs: ['Tableau', 'Réunion', 'Email'],
    demoColumns: ['À préparer', 'En cours', 'Terminé'],
    demoTasks: [
      'Valider le parcours client',
      'Préparer les contenus',
      'Affiner la page d’accueil',
      'Partager la première version',
    ],
    demoLabels: ['Produit', 'Contenu', 'Design', 'Équipe'],
    demoDue: 'Aujourd’hui',
    demoTeam: 'Équipe projet',
    demoMeeting: 'Point projet · lancement',
    demoTranscript:
      '« On doit simplifier le parcours avant la prochaine revue. Léa, tu peux préparer une première proposition ? »',
    demoMail: 'Objet : prochaines étapes du lancement',
    demoMailText:
      'Bonjour l’équipe, voici les points à préparer pour notre prochaine revue : finaliser la page d’accueil et partager les contenus.',
    demoProposal: 'Proposition de tâche à relire',
    demoAction: 'Préparer une proposition de parcours',
    demoMailAction: 'Finaliser la page d’accueil',
    demoReview: 'Vous relisez. Vous décidez.',
    demoSource: 'Le contexte reste à portée de main.',
    strip: ['Projets & tâches', 'Réunions & emails', 'Assistant IA', 'Équipe & reporting'],
    flowLabel: '01 / DU CONTEXTE À L’ACTION',
    flowTitle: 'Une conversation ne devrait pas devenir une tâche oubliée.',
    flowIntro:
      'Le travail commence souvent ailleurs que dans un tableau. NeoKanban vous aide à faire le lien.',
    steps: [
      [
        'Rassemblez les échanges',
        'Importez vos enregistrements, retrouvez vos réunions et connectez votre messagerie.',
      ],
      [
        'Faites émerger les actions',
        'Transcription, résumés et propositions de tâches vous aident à passer de la discussion à un plan concret.',
      ],
      [
        'Gardez la main',
        'Relisez les propositions, précisez le responsable et l’échéance, puis suivez le travail dans le projet.',
      ],
    ],
    featureLabel: '02 / UN ESPACE DE TRAVAIL COMPLET',
    featureTitle: 'Le détail compte. La vue d’ensemble aussi.',
    featureIntro:
      'De la petite action au projet collectif, retrouvez les outils utiles au même endroit.',
    features: [
      [
        'Organiser',
        'Des projets qui restent lisibles.',
        [
          'Projets, tableaux et colonnes personnalisables',
          'Vues Kanban, liste, tableau, calendrier et chronologie',
          'Vue fichiers pour retrouver les pièces jointes',
          'Recherche, filtres et étiquettes',
        ],
      ],
      [
        'Exécuter',
        'Chaque tâche a son contexte.',
        [
          'Priorités, responsables et échéances',
          'Sous-tâches et suivi de progression',
          'Descriptions, commentaires et pièces jointes',
          'Champs personnalisés selon vos projets',
        ],
      ],
      [
        'Comprendre',
        'Moins de temps à reprendre des notes.',
        [
          'Import audio et vidéo, transcription de réunions',
          'Résumés et extraction de propositions de tâches',
          'Emails et suggestions d’actions associées',
          'Assistant IA conversationnel et recherche',
        ],
      ],
      [
        'Collaborer',
        'Un cap commun pour l’équipe.',
        [
          'Organisations, membres et invitations',
          'Accès aux projets et rôles des membres',
          'Notifications et préférences personnelles',
          'Tableaux de bord, analyses et rapports',
        ],
      ],
    ],
    integrationLabel: '03 / CONNECTÉ À VOTRE QUOTIDIEN',
    integrationTitle: 'Vos outils ont leur place ici.',
    integrationIntro:
      'Reliez vos sources de travail et vos assistants. Les connexions disponibles dépendent de la configuration de votre espace.',
    integrations: [
      ['Messagerie', 'Comptes email et collecte des messages.'],
      ['Calendrier', 'Connexion Google Calendar pour vos rendez-vous.'],
      ['Plaud', 'Import des enregistrements de votre appareil.'],
      ['API & MCP', 'Accès pour vos assistants et vos workflows externes.'],
    ],
    hostingLabel: '04 / LE CHOIX DE L’HÉBERGEMENT',
    hostingTitle: 'Votre espace. Votre façon de travailler.',
    hostingIntro:
      'Deux offres professionnelles, un même produit. Choisissez qui exploite votre environnement.',
    saasTitle: 'NeoKanban Cloud',
    saasText:
      'Concentrez-vous sur vos projets. Votre espace SaaS est hébergé en France, sur l’infrastructure Sponge Theory.',
    saasItems: [
      'Accès depuis votre navigateur',
      'Infrastructure exploitée par Sponge Theory',
      'Abonnement adapté à votre équipe',
    ],
    pricing: 'Voir les offres SaaS',
    selfTitle: 'Sur votre infrastructure',
    selfText:
      'Déployez NeoKanban dans votre environnement, avec un périmètre de licence et d’accompagnement convenu ensemble.',
    selfItems: [
      'Hébergement sous votre responsabilité',
      'Configuration des connexions et de SPT Models',
      'Licence et accompagnement sur devis',
    ],
    contact: 'Parlons auto-hébergement',
    hostingNote:
      'Les connexions externes peuvent traiter des données hors de votre environnement. La génération de texte utilise Qwen via SPT Models.',
    faqTitle: 'Les questions avant de se lancer.',
    faqs: [
      [
        'À qui s’adresse NeoKanban ?',
        'Aux indépendants, équipes et organisations qui utilisent le service dans un cadre professionnel. Les offres sont réservées aux professionnels.',
      ],
      [
        'Quelles vues sont disponibles ?',
        'Kanban, liste, tableau, calendrier, chronologie et fichiers : plusieurs façons de consulter le même travail, selon votre besoin du moment.',
      ],
      [
        'Quel rôle joue l’IA ?',
        'Elle peut transcrire, résumer, rechercher et proposer des actions à partir de vos échanges. Les résultats peuvent comporter des erreurs : relisez les propositions avant de les utiliser. Les fonctions activées dépendent des fournisseurs configurés.',
      ],
      [
        'Où sont hébergées les données ?',
        'Le SaaS est hébergé sur l’infrastructure Sponge Theory en France. En auto-hébergement, vous choisissez votre infrastructure. La localisation des traitements des services connectés dépend de leurs propres conditions.',
      ],
      [
        'Peut-on l’héberger soi-même ?',
        'Oui. Contactez-nous pour définir la licence, le déploiement, les mises à jour et l’accompagnement adaptés à votre organisation.',
      ],
      [
        'Comment connaître le prix et les limites ?',
        'La page des offres présente les plans SaaS disponibles et leurs limites. Pour une installation sur votre infrastructure ou un besoin spécifique, demandez un devis.',
      ],
    ],
    finalTitle: 'Faites de la place au travail qui avance.',
    finalText: 'Un espace pour relier les échanges, les décisions et les prochaines actions.',
    footer: 'Du contexte à l’action.',
    product: 'Produit',
    legal: 'Informations légales',
    company: 'Une solution Sponge Theory',
    b2b: 'Réservé aux professionnels.',
    cookies: 'Gérer les cookies',
    notice: 'Mentions légales',
    terms: 'CGU',
    sales: 'CGV professionnelles',
    privacy: 'Confidentialité',
    ai: 'Transparence IA',
    rights: 'Tous droits réservés.',
    description:
      'NeoKanban réunit projets, tâches, réunions, emails et assistant IA. Pour les professionnels : SaaS hébergé en France ou auto-hébergement.',
  },
  en: {
    nav: ['Features', 'Hosting', 'Questions'],
    login: 'Sign in',
    start: 'Create my workspace',
    dashboard: 'Open my workspace',
    skip: 'Skip to content',
    menu: 'Navigation',
    eyebrow: 'YOUR WORK, FROM THE FIRST CONVERSATION TO THE LAST DETAIL',
    title: 'Less scattered.',
    emphasis: 'More accomplished.',
    intro:
      'Give your projects, meetings and emails a place to come together. Turn conversations into tasks, keep the context and move your team forward.',
    explore: 'Explore the product',
    professional: 'For professionals · SaaS hosted in France or self-hosted',
    demo: 'Illustrative product preview',
    demoProject: 'New website launch',
    demoWorkspace: 'My workspace',
    demoTabs: ['Board', 'Meeting', 'Email'],
    demoColumns: ['To prepare', 'In progress', 'Done'],
    demoTasks: [
      'Review the customer journey',
      'Prepare the content',
      'Refine the homepage',
      'Share the first version',
    ],
    demoLabels: ['Product', 'Content', 'Design', 'Team'],
    demoDue: 'Today',
    demoTeam: 'Project team',
    demoMeeting: 'Project check-in · launch',
    demoTranscript:
      '“We need to simplify the journey before the next review. Lea, could you prepare a first proposal?”',
    demoMail: 'Subject: next steps for the launch',
    demoMailText:
      'Hi team, here are the items to prepare for our next review: finish the homepage and share the content.',
    demoProposal: 'Suggested task for review',
    demoAction: 'Prepare a customer journey proposal',
    demoMailAction: 'Finish the homepage',
    demoReview: 'You review. You decide.',
    demoSource: 'Keep the context close to the work.',
    strip: ['Projects & tasks', 'Meetings & emails', 'AI assistant', 'Team & reporting'],
    flowLabel: '01 / FROM CONTEXT TO ACTION',
    flowTitle: 'A conversation should never become a forgotten task.',
    flowIntro: 'Work often starts outside a board. NeoKanban helps you connect the dots.',
    steps: [
      [
        'Bring conversations together',
        'Import recordings, find your meetings and connect your mailbox.',
      ],
      [
        'Find the next actions',
        'Transcripts, summaries and task suggestions help turn a discussion into a concrete plan.',
      ],
      [
        'Stay in control',
        'Review suggestions, set an owner and a due date, then follow the work in your project.',
      ],
    ],
    featureLabel: '02 / A COMPLETE WORKSPACE',
    featureTitle: 'The details matter. So does the bigger picture.',
    featureIntro: 'From a small action to a shared project, keep the tools you need in one place.',
    features: [
      [
        'Organize',
        'Projects you can make sense of.',
        [
          'Projects, boards and customizable columns',
          'Kanban, list, table, calendar and timeline views',
          'A files view to find your attachments',
          'Search, filters and labels',
        ],
      ],
      [
        'Deliver',
        'Every task keeps its context.',
        [
          'Priorities, assignees and due dates',
          'Subtasks and progress tracking',
          'Descriptions, comments and attachments',
          'Custom fields for your projects',
        ],
      ],
      [
        'Understand',
        'Spend less time taking notes again.',
        [
          'Audio and video imports, meeting transcription',
          'Summaries and suggested action items',
          'Emails with related action suggestions',
          'Conversational AI assistant and search',
        ],
      ],
      [
        'Collaborate',
        'A shared direction for your team.',
        [
          'Organizations, members and invitations',
          'Project access and member roles',
          'Notifications and personal preferences',
          'Dashboards, analytics and reports',
        ],
      ],
    ],
    integrationLabel: '03 / CONNECTED TO YOUR DAY',
    integrationTitle: 'Your tools belong here.',
    integrationIntro:
      'Connect your sources of work and your assistants. Available connections depend on your workspace configuration.',
    integrations: [
      ['Email', 'Mailbox connections and message collection.'],
      ['Calendar', 'Google Calendar connection for your events.'],
      ['Plaud', 'Import recordings from your device.'],
      ['API & MCP', 'Access for assistants and external workflows.'],
    ],
    hostingLabel: '04 / YOUR HOSTING CHOICE',
    hostingTitle: 'Your workspace. Your way of working.',
    hostingIntro: 'Two professional offers, one product. Choose who operates your environment.',
    saasTitle: 'NeoKanban Cloud',
    saasText:
      'Focus on your projects. Your SaaS workspace is hosted in France on Sponge Theory infrastructure.',
    saasItems: [
      'Access from your browser',
      'Infrastructure operated by Sponge Theory',
      'A subscription for your team',
    ],
    pricing: 'See SaaS plans',
    selfTitle: 'On your infrastructure',
    selfText:
      'Deploy NeoKanban in your environment, with a license and support scope agreed together.',
    selfItems: [
      'Hosting under your responsibility',
      'Configure connections and SPT Models',
      'License and support by quotation',
    ],
    contact: 'Discuss self-hosting',
    hostingNote:
      'Connected services may process data outside your hosting environment. Text generation uses Qwen through SPT Models.',
    faqTitle: 'Before you get started.',
    faqs: [
      [
        'Who is NeoKanban for?',
        'Independent professionals, teams and organizations using the service for business purposes. Our offers are exclusively for professional customers.',
      ],
      [
        'Which views are available?',
        'Kanban, list, table, calendar, timeline and files: different ways to look at the same work, depending on what you need.',
      ],
      [
        'What does the AI do?',
        'It can transcribe, summarize, search and suggest actions from your conversations. Results may contain errors: review suggestions before using them. Enabled features depend on configured providers.',
      ],
      [
        'Where is data hosted?',
        'The SaaS service runs on Sponge Theory infrastructure in France. With self-hosting, you choose your infrastructure. Processing locations for connected services depend on their own terms.',
      ],
      [
        'Can we self-host it?',
        'Yes. Contact us to agree on the license, deployment, updates and support that fit your organization.',
      ],
      [
        'Where can I find prices and limits?',
        'The plans page shows available SaaS plans and their limits. Request a quote for a self-hosted installation or a specific requirement.',
      ],
    ],
    finalTitle: 'Make room for work that moves forward.',
    finalText: 'One workspace for conversations, decisions and next steps.',
    footer: 'From context to action.',
    product: 'Product',
    legal: 'Legal information',
    company: 'A Sponge Theory product',
    b2b: 'For professional customers only.',
    cookies: 'Manage cookies',
    notice: 'Legal notice',
    terms: 'Terms of use',
    sales: 'Business terms of sale',
    privacy: 'Privacy',
    ai: 'AI transparency',
    rights: 'All rights reserved.',
    description:
      'NeoKanban brings projects, tasks, meetings, emails and an AI assistant together. For professionals: SaaS hosted in France or self-hosting.',
  },
};
export type PublicLanguage = keyof typeof marketing;
